import {pessoaTipoChoices, ProprietarioObject} from "../../models/Proprietario";
import React from "react";
import {AppUser} from "../../models/app";


export const proprietarioCardSubtitle = (i: ProprietarioObject) => (
  <>
    Prorietário
    {i.pessoa_tipo &&
      <span> ({pessoaTipoChoices.getLabel(i.pessoa_tipo)})</span>
    }
  </>
);

export const proprietarioCardTitle = (i: ProprietarioObject) => (
  <>
    {i.nome}
  </>
);


interface ProprietarioCardContentProps {
  user: AppUser;
  proprietario: ProprietarioObject;
  numFazendas?: number;
}

export const ProprietarioCardContent = (props: ProprietarioCardContentProps) => {
  const {proprietario, numFazendas} = props;

  return (
    <>
      <div>{proprietario.telefone}</div>
      {(proprietario.cidade || proprietario.estado) &&
        <div className="flex gap-4">
          {proprietario.cidade &&
            <div>{proprietario.cidade}</div>
          }
          {proprietario.estado &&
            <div>{proprietario.estado}</div>
          }
        </div>
      }
      {numFazendas !== undefined &&
        <div className="text-xs text-gray-500 text-center mt-2 flex items-center gap-2 justify-center">
          <div>Fazendas:</div>
          <div>
            {numFazendas}
          </div>
        </div>
      }
    </>
  )
}